import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { ChannelsService } from '@app/services/channels.service';
import { SharedService } from '@app/services/shared.service';
import { UserService } from '@app/services/user.service';
import { ChannelCardComponent } from '@app/components/channel-card/channel-card.component';

@Component({
  selector: 'blu-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [RouterLink, RouterOutlet, ChannelCardComponent],
})
export class ChannelsComponent implements OnInit {
  private router = inject(Router);
  userService = inject(UserService);
  sharedService = inject(SharedService);
  channelsService = inject(ChannelsService);

  activeFilter = signal<'agents' | 'flows' | 'operators' | null>(null);

  filteredChannels = computed(() => {
    const channels = this.channelsService.chatbotChannels();
    const filter = this.activeFilter();

    if (!filter) return channels;

    return channels.filter((channel) => {
      switch (filter) {
        case 'agents':
          return channel.activeAgent;
        case 'flows':
          return channel.activeFlow;
        case 'operators':
          return channel.operators.length > 0;
        default:
          return true;
      }
    });
  });

  canAddAgent = computed(() => {
    const limit = this.userService.getAgentLimit();
    const agentChannelsCount = this.channelsService
      .chatbotChannels()
      .reduce((count, channel) => count + (channel.activeAgent ? 1 : 0), 0);
    return (
      limit > agentChannelsCount || (limit === 0 && agentChannelsCount < 1)
    );
  });

  toggleFilter(filter: 'agents' | 'flows' | 'operators') {
    if (this.activeFilter() === filter) {
      this.activeFilter.set(null);
    } else {
      this.activeFilter.set(filter);
    }
  }

  ngOnInit(): void {
    this.init();
  }

  async init() {
    const org = this.userService.organization();
    if (!org) {
      this.router.navigate(['/sign-in/admin']);
      return;
    }
    await this.channelsService.getChannels(org.uid);
  }
}
